import { useState } from "react";
import Joi from "joi-browser";

export default useConfigureForm;

function useConfigureForm(state, formSchema, validationErrors = {}) {
  const [formState, setFormState] = useState(state);
  const [errors, setErrors] = useState(validationErrors);

  const validate = () => {
    const schema = Joi.object(formSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      if (detail.path.length > 1) {
        // Array field — e.g. path: ['tags', 0]
        const field = detail.path[0];
        const index = detail.path[1];
        if (!Array.isArray(fieldErrors[field])) {
          fieldErrors[field] = [];
        }
        fieldErrors[field][index] = detail.message;
      } else {
        fieldErrors[detail.path[0]] = detail.message;
      }
    });

    setErrors(fieldErrors);
    return false;
  };

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  return {
    formState,
    errors,
    updateFormState,
    validate,
    setFormState,
  };
}
